import { render } from "./LiteIntegrationAssets.vue?vue&type=template&id=fb1f8d7a"
import script from "./LiteIntegrationAssets.vue?vue&type=script&lang=js"
export * from "./LiteIntegrationAssets.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__